export default function frenchTime(value: string) {
  const date = new Date(value)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return [hours, minutes].join(':')
}
